import { render, staticRenderFns } from "./pendingIncident.vue?vue&type=template&id=391cad89&scoped=true"
import script from "./pendingIncident.vue?vue&type=script&lang=js"
export * from "./pendingIncident.vue?vue&type=script&lang=js"
import style0 from "./pendingIncident.vue?vue&type=style&index=0&id=391cad89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391cad89",
  null
  
)

export default component.exports